import { Filter } from "../models/Filter";

export type FilterClearPolicy = "removable" | "restore-default" | "locked";

export const resolveFilterClearPolicy = (filter?: Filter): FilterClearPolicy => {
    if (!filter) {
        return "removable";
    }

    if (filter.clearPolicy) {
        return filter.clearPolicy;
    }

    // Default static filters to restore-default so legacy static filter definitions
    // continue to behave as "always present" even when clearPolicy is not explicitly set.
    if (filter.isStatic) {
        return "restore-default";
    }

    return "removable";
};

export const shouldRestoreFilterOnClear = (filter?: Filter): boolean => {
    const policy = resolveFilterClearPolicy(filter);
    return policy === "restore-default" || policy === "locked";
};

export const isClearLocked = (filter?: Filter): boolean => {
    return resolveFilterClearPolicy(filter) === "locked";
};

export const isStaticDefaultState = (filter?: Filter): boolean => {
    return !!filter?.selected?.length && filter.selected.every((option) => option.ignore);
};
